module.exports = __webpack_public_path__ + "static/media/0014.aa7f3cf4.jpg";